import * as Sentry from "@sentry/nextjs"

import { ParticipationDetailsFormAttributes } from "@modules/tenants/OrdersPage/Components/AddOrderModal/ParticipationDetailsForm/ParticipationDetailsForm"
import {
  useAddMultipleAddonToOrderItemMutation,
  useDeleteNonBookableOrderItemMutation,
  useUpdateAddonOfOrderItemMutation,
} from "@mono/essentials/entities/order/hooks"
import {
  AddAddonToOrderItemRequestType,
  GetOrderDetailsResponseType,
} from "@mono/essentials/types/OrderTypes"

export const useHandleUpdateBookingAddonDetails = () => {
  const { mutateAsync: deleteNonBookableOrderItemMutation } =
    useDeleteNonBookableOrderItemMutation()
  const { mutateAsync: addMultipleAddonToOrderItemMutation } =
    useAddMultipleAddonToOrderItemMutation()
  const { mutateAsync: updateAddonOfOrderItemMutation } = useUpdateAddonOfOrderItemMutation()

  const handleUpdateBookingAddonDetails = async ({
    values,
    onSuccess,
    onError,
    orderData,
    orderItemId,
  }: {
    values: ParticipationDetailsFormAttributes
    orderItemId: string
    orderData: GetOrderDetailsResponseType
    onSuccess?: () => Promise<void>
    onError?: (error: any) => Promise<void>
  }) => {
    try {
      if (values?.addonDetails?.length && orderData?.id && orderItemId) {
        const parentBookingId = orderData.items?.find((orderItem) => orderItem.id === orderItemId)
          ?.booking?.id
        const deleteAddonsPayload: string[] = []
        const updateAddonsPayload: (AddAddonToOrderItemRequestType & {
          order_item_id?: string
        })[] = []
        values.addonDetails.forEach((addon) => {
          addon.units?.forEach((addonUnit) => {
            if (addonUnit.unitCount === 0) {
              if (addonUnit.id) deleteAddonsPayload.push(addonUnit.id)
            } else {
              updateAddonsPayload.push({
                product_id: addon.addonId,
                booking_participant_id: addonUnit.participantId
                  ? addonUnit.participantId
                  : undefined,
                order_item_id: addonUnit.id,
                quantities: [
                  {
                    quantity: addonUnit.unitCount,
                    unit_id: addonUnit.unitId ?? "",
                    booking_id: parentBookingId,
                  },
                ],
              })
            }
          })
        })

        // Deleting the existing add-on order-items
        if (deleteAddonsPayload.length) {
          // TODO: Need BE support to delete multiple item at once
          // eslint-disable-next-line no-restricted-syntax
          for (const deleteAddonPayload of deleteAddonsPayload) {
            // eslint-disable-next-line no-await-in-loop
            await deleteNonBookableOrderItemMutation({
              orderId: orderData?.id,
              orderItemId: deleteAddonPayload,
            })
          }
          // await Promise.all(
          //   deleteAddonsPayload.map(addonOrderItemId =>
          //     OrderServices.deleteNonBookableOrderItem(orderData?.id, addonOrderItemId)
          //   )
          // )
        }

        if (updateAddonsPayload?.length) {
          const addMultipleAddonToOrderItemPayload = updateAddonsPayload.filter(
            (addon) => !addon?.order_item_id
          )
          const updateMultipleAddonToOrderItemPayload = updateAddonsPayload.filter((addon) =>
            Boolean(addon?.order_item_id)
          )
          // Creating an add-on
          if (addMultipleAddonToOrderItemPayload?.length) {
            await addMultipleAddonToOrderItemMutation({
              orderId: orderData?.id,
              orderItemId,
              body: {
                items: addMultipleAddonToOrderItemPayload,
              },
            })
          }
          // Update the existing add-on order-item
          if (updateMultipleAddonToOrderItemPayload?.length) {
            // TODO: Need BE support to update multiple item at once
            // eslint-disable-next-line no-restricted-syntax
            for (const updateAddonPayload of updateMultipleAddonToOrderItemPayload) {
              if (updateAddonPayload?.order_item_id)
                // eslint-disable-next-line no-await-in-loop
                await updateAddonOfOrderItemMutation({
                  orderId: orderData?.id,
                  orderItemId: updateAddonPayload?.order_item_id,
                  body: updateAddonPayload,
                })
            }
            // await Promise.all(
            //   updateMultipleAddonToOrderItemPayload.map(updateAddonToOrderItemPayload => {
            //     if (updateAddonToOrderItemPayload?.order_item_id) {
            //       return OrderServices.updateAddonOfOrderItem(
            //         orderData?.id,
            //         updateAddonToOrderItemPayload?.order_item_id,
            //         {
            //           quantities: updateAddonToOrderItemPayload.quantities
            //         }
            //       )
            //     }
            //   })
            // )
          }
        }

        await onSuccess?.()
      }
    } catch (error) {
      Sentry.captureException(error)
      await onError?.(error)
    }
  }

  return { handleUpdateBookingAddonDetails }
}
